import {makeAutoObservable, runInAction} from 'mobx';
import {makeLoggable} from 'mobx-log';

import {AirtableBrand} from '../models/airtable';
import apiService from '../transport/apiService';
import {logger, serializeError} from '../utils/logger';

import {GIFT_CARDS_TILE, SPECIALS_TILE} from './rangeStore';
import type {RootStore} from './rootStore';

export class BrandsStore {
  rootStore: RootStore;
  brands: AirtableBrand[] = [];
  loadingLinked = false;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
    makeLoggable(this);

    this.reset();
  }

  loadLinkedProductsForBrand = async (brand: {brand: any}) => {
    const linked = {};

    await Promise.all(
      this.rootStore.rangeStore?.departments
        ?.filter(
          (dep: any) =>
            dep.parent &&
            dep.parent.id === this.rootStore.rangeStore.parentDepartment?.id &&
            dep.name !== 'Balanced Lifestyle' &&
            dep.id !== SPECIALS_TILE &&
            dep.id !== GIFT_CARDS_TILE,
        )
        .map(async (department: any) => {
          logger.debug('BrandsStore', 'Loading products for brand and department', {
            brand: brand.brand,
            department: department.name,
          });
          const products: any = await apiService.getProductsByDepartmentAndBrand(brand, department);
          if (products.length) {
            // @ts-expect-error - Type mismatch needs investigation
            linked[department.name] = products;
          }
        }),
    );
    return linked;
  };

  reset = () => {
    runInAction(() => {
      this.loadingLinked = false;
    });
  };

  loadBrands = async () => {
    try {
      const brands = await apiService.getBrands();
      runInAction(() => {
        this.brands = brands;
      });
    } catch (err) {
      logger.error('BrandsStore', 'Error loading brands', serializeError(err));
    }
  };
}
